import * as React from "react";
import * as ReactDOM from "react-dom";

export class Example extends React.Component<{}, {}> {
    render() {
        return <p><i>Example:</i></p>;
    }
}